import {Payload} from '../../../../core/service/payload/payload';

export class ProductSavePayload implements Payload {

    code: string;
    label: string;
    invoiceLabel: string;
    categoryValue: string;
    typeValue: string;
    description: string;
    comment: string;

    priceVatExcluded: number;
    priceVatIncluded: number;
    advanceVatIncluded: number;
    advanceVatExcluded: number;

    taxPercentage: number;
    stock: number;
    active: boolean;
    colorValue: string;

}
